import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, FormHelperText } from '@mui/material';
import { useFormTheme } from '../../../contexts/FormThemeContext'; // Adjust the import path as necessary

const TypographySettings = () => {
  const { fonts, handleFontChange } = useFormTheme(); // Use context for font settings
  if (!fonts) return null;

  const fontsList = [
    { name: 'Arial', value: 'Arial, sans-serif' },
    { name: 'Courier Prime', value: '"Courier Prime", monospace' },
    { name: 'Georgia', value: 'Georgia, serif' },
    { name: 'Merriweather', value: 'Merriweather, serif' },
    { name: 'Montserrat', value: 'Montserrat, sans-serif' },
    { name: 'Open Sans', value: '"Open Sans", sans-serif' },
    { name: 'Roboto', value: 'Roboto, sans-serif' },
    { name: 'Roboto Slab', value: 'Roboto Slab, serif' },
    { name: 'Source Sans Pro', value: '"Source Sans Pro", sans-serif' },
    { name: 'Times New Roman', value: '"Times New Roman", Times, serif' }
  ];

  return (
    <Box sx={{ width: '100%', p: '0 4px 0 4px' }}>
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel id="primary-font-label">Primary Font</InputLabel>
        <Select
          labelId="primary-font-label"
          id="primary-font-select"
          value={fonts.primaryFont}
          label="Primary Font"
          onChange={(e) => handleFontChange('primaryFont', e.target.value)}
        >
          {fontsList.map((font) => (
            <MenuItem key={font.value} value={font.value} style={{ fontFamily: font.value }}>
              {font.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>(i.e., Header or Subheader)</FormHelperText>
      </FormControl>

      <FormControl fullWidth size="small">
        <InputLabel id="secondary-font-label">Secondary Font</InputLabel>
        <Select
          labelId="secondary-font-label"
          id="secondary-font-select"
          value={fonts.secondaryFont}
          label="Secondary Font"
          onChange={(e) => handleFontChange('secondaryFont', e.target.value)}
        >
          {fontsList.map((font) => (
            <MenuItem key={font.value} value={font.value} style={{ fontFamily: font.value }}>
              {font.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>(i.e., Questions or Body text)</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default TypographySettings;
